class NewMsisdnNotification {

    [x: string]: any;
    static $inject = ['NotificationsService'];
    constructor(NotificationsService) {
        this.NotificationsService = NotificationsService;
    }

    dismissNotification() {
        this.NotificationsService.delete({id: this.notification.notificationId}, () => this.onDelete());
    }
}

export default {
    controller: NewMsisdnNotification,
    template: require('./new.msisdn.html'),
    bindings: {
        notification: '<',
        onDelete: '&'
    }
};
